import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  NbAccordionModule,
  NbActionsModule,
  NbAlertModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbPopoverModule,
  NbRadioModule,
  NbRouteTabsetModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbTreeGridModule,
  NbUserModule,
} from '@nebular/theme';

import { EquipmentDetailComponent } from './equipmentdetail.component';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerInputModule } from '../../../shared/component/customers/input/customer-input.module';
import { DynamicListViewModule } from '../../../shared/component/dynamiclistview/dynamiclistview.module';
import { DynamicInputModule } from '../../../shared/component/dynamiclistview/dynamic-input/dynamic-input.module';
import { AttachmentsModule } from '../../attachments/attachments.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { DispatchHubModule } from '../../dispatchhub/dispatchhub.module';
import { EquipmentRoutingModule } from '../equipment-routing.module';
import { ChecklistDetailComponent } from '../../checklist/components/checklist-detail/checklist-detail.component';
import { EquipmentCountingJournalModule } from '../../equipment-counting-journal/equipment-counting-journal.module';
import { WorkOrderListComponent } from '../../workorder/components/workorder-list/workorder-list.component';
import { WarrantyCertificateSectionComponent } from '../components/warranty-certificate/warranty-certificate-section.component';
import { EquipmentWalkaroundsComponent } from '../../checklist/components/walkaround-summary/equipment-walkarounds.component';

@NgModule({
  declarations: [EquipmentDetailComponent],
  exports: [EquipmentDetailComponent],
  imports: [
    CommonModule,
    EquipmentRoutingModule,
    NbAccordionModule,
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbContextMenuModule,
    NbDatepickerModule,
    NbDialogModule,
    NbIconModule,
    NbInputModule,
    NbRouteTabsetModule,
    NbLayoutModule,
    NbListModule,
    NbRadioModule,
    NbPopoverModule,
    NbSelectModule,
    NbTagModule,
    NbTabsetModule,
    NbTreeGridModule,
    NbUserModule,
    NbAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AttachmentsModule,
    CustomerInputModule,
    DynamicListViewModule,
    DynamicInputModule,
    NzTabsModule,
    NzTooltipModule,
    DispatchHubModule,
    NbAlertModule,
    NbTagModule,
    NbSpinnerModule,
    ChecklistDetailComponent,
    EquipmentCountingJournalModule,
    WorkOrderListComponent,
    WarrantyCertificateSectionComponent,
    EquipmentWalkaroundsComponent,
  ],
})
export class EquipmentDetailModule {}
